// en — English. Keys mirror zh-Hant.js.

export default {
  'app.title':           'Finance',
  'app.loading':         'Loading...',
  'nav.dashboard':       'Dashboard',
  'nav.transactions':    'Transactions',
  'nav.budgets':         'Budgets',
  'nav.settings':        'Settings',
  'bottomnav.aria':      'Main navigation',
  'sidebar.aria':        'Desktop navigation',

  'topbar.theme':        'Toggle theme',
  'topbar.quickAdd':     'Add transaction',

  'dashboard.title':     'Dashboard',
  'dashboard.income':    'Income',
  'dashboard.expense':   'Expense',
  'dashboard.net':       'Net',
  'dashboard.networth': 'Net worth',
  'dashboard.networthHelper': 'Total income − total expenses, all time',
  'dashboard.networthPositive': 'positive',
  'dashboard.networthNegative': 'in the red',
  'dashboard.savings':   'Savings rate',
  'dashboard.balance':   'Balance',
  'dashboard.vsLast':    'vs last month',
  'kpi.noComparison': 'No prior period',
  'dashboard.rangeLabel': 'Range',
  'dashboard.rangeHint': 'Click to jump to current period · Right-click to switch Day/Month/Year/5Y',
  'dashboard.vsYesterday':'Yesterday',
  'dashboard.vsLastYear':'vs last year',
  'dashboard.range.day': 'Day',
  'dashboard.range.month':'Month',
  'dashboard.range.year':'Year',
  'dashboard.range.5y': '5Y',
  'dashboard.prevPeriod':'Previous period',
  'dashboard.nextPeriod':'Next period',
  'dashboard.allCats':   'All',
  'dashboard.autoApplied':'Auto-recorded {n} recurring transactions',
  'dashboard.forecast.title': 'Cash flow forecast',
  'dashboard.forecast.subtitle': 'Projected balance over the next 30 days, based on your recurring rules',
  'dashboard.forecast.todayBalance': 'Today\'s balance',
  'dashboard.forecast.projection30d': 'Projected (+30 days)',
  'dashboard.forecast.delta': 'vs today',
  'dashboard.forecast.activeCount': '{n} active rules',
  'dashboard.forecast.income': 'Income',
  'dashboard.forecast.expense': 'Expense',
  'dashboard.forecast.legend.balance': 'Projected balance',
  'dashboard.forecast.legend.events': 'Income / Expense events',
  'dashboard.forecast.empty.title': 'No forecast available yet',
  'dashboard.forecast.empty.body': 'Set up recurring transactions to see your projected cash flow for the next 30 days.',
  'dashboard.forecast.empty.cta': 'Set up recurring →',
  'dashboard.forecast.tooltip.balance': 'Balance',
  'dashboard.forecast.tooltip.events': '# events',

  'tx.title':            'Transactions',
  'transactions.openFilters': 'Filters',
  'transactions.filters': 'Filters',
  'transactions.filterDrawerTitle': 'Filter transactions',
  'transactions.typeLabel': 'Type',
  'transactions.categoryLabel': 'Category',
  'transactions.searchLabel': 'Search',
  'transactions.removeFilter': 'Remove filter: {name}',
  'transactions.resetFilters': 'Reset',
  'transactions.applyFilters': 'Apply',
  'transactions.cardsTitle': 'Credit cards',
  'transactions.cardFilterActive': 'filter active',
  'transactions.filterByCard': 'Filter to {name}’s transactions',
  'transactions.unfilterCard': 'Show all cards (clear filter)',
  'transactions.noCardMatch': 'No transactions for this card in the current period',
  'tx.search':           'Search note or category',
  'tx.empty':            'No transactions yet',
  'tx.emptyHint':        'Tap the button below to add the first one',
  'tx.thisMonth':        'This month',
  'tx.lastMonth':        'Last month',
  'tx.last30':           'Last 30 days',
  'tx.ytd':              'Year to date',
  'tx.all':              'All',
  'tx.expense':          'Expense',
  'tx.income':           'Income',
  'tx.allPeriod':        'All time',
  'tx.allCats':          'All categories',
  'tx.tagLabel':         'Tags:',
  'tx.edit':             'Edit',
  'tx.delete':           'Delete',
  'tx.deleteConfirm':    'Delete this transaction?',
  'tx.bulkSelected':     '{n} selected',
  'tx.bulkCancel':       'Cancel',
  'tx.bulkSelectAll':    'Select all',
  'tx.bulkClear':        'Clear selection',
  'tx.bulkDeleteConfirm':'Delete the {n} selected transactions?',
  'tx.bulkDeleted':      'Deleted {n} transactions',
  // Phase 111: recurring badge
  'tx.recurring':        'Recurring',

  'add.newTitle':        'New transaction',
  'add.editTitle':       'Edit transaction',
  'add.expense':         'Expense',
  'add.income':          'Income',
  'add.amount':          'Amount',
  'add.category':        'Category',
  'add.date':            'Date',
  'add.note':            'Note',
  'add.notePlaceholder': 'optional',
  // Phase 80: mode-toggle buttons inside the add modal.
  'add.modeAdd':         'Add',
  'add.modeTransfer':    'Transfer',
  // Phase 80: single merged payment-method picker.
  'add.paymentMethod':   'Payment method',
  'add.tags':            'Tags',
  'add.tagsPlaceholder': 'comma-separated',
  'add.card':            'Credit card',
  'add.cardNone':        'None',
  'add.today':           'Today',
  // Phase 203: quick date chips in the Add Transaction form.
  'add.yesterday':       'Yest.',
  'add.dayBefore':       '2d ago',
  // Phase 186 (M-113): Advanced accordion (collapses tags/note/bulk).
  'add.advanced':        'Advanced',
  // Phase 189 (M-116): pager controls (prev/next arrows + dot indicator).
  'addCategoryPager.prev': 'Previous page',
  'addCategoryPager.next': 'Next page',
  'addCategoryPager.pageIndicator': 'Page {n} of {total}',
  // Phase 189 (M-116): AddCategoryModal drawer labels.
  'addCategory.title':          'New category',
  'addCategory.newCategory':    '+ New category',
  'addCategory.nameLabel':      'Name',
  'addCategory.namePlaceholder':'e.g. Coffee fund',
  'addCategory.iconLabel':      'Icon',
  'addCategory.colorLabel':     'Color',
  // Phase 49: bulk apply to date range
  'bulk.applyToRange':   'Apply to date range',
  'bulk.endDate':        'End date',
  'bulk.dayOfWeek':      'Day of week',
  'bulk.weekdayShort':   ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  'bulk.presetWeekdays': 'Weekdays (M–F)',
  'bulk.presetEveryDay': 'Every day',
  'bulk.presetMWF':      'M / W / F',
  'bulk.preview':        'Will create {count} transactions',
  'bulk.emptyRange':     'No dates match the range',
  'add.cancel':          'Cancel',
  'add.save':            'Save',
  'add.saved':           'Saved',
  'add.failed':          'Save failed: {msg}',

  'budgets.title':       'Budgets',
  'budgets.empty':       'No budgets yet',
  'budgets.emptyHint':   'Tap "Set limit" on any category to save one',
  'budgets.setLimit':    'Set limit',
  'budgets.used':        'used',
  'budgets.of':          'of',
  'budgets.overBudget':  'Over budget!',
  'budgets.heroTotal':   'Total budget this month',
  'budgets.heroRemaining': '{amount} left',
  'budgets.heroOverBy':  '{amount} over',
  'budgets.heroNoBudgets': 'No budgets yet this month',
  'budgets.heroNoBudgetsHint': 'Set a limit on a category to start tracking',
  'budgets.heroPctAria': 'Total budget used {pct}',

  // ─── Savings Goals (Phase 48) ────────────────────────────────────────
  'goals.title':                  'Savings goals',
  'goals.widgetTitle':            'Savings goals ({n})',
  'goals.widgetEmpty':            'Set a goal to track your progress',
  'goals.summary':                'Goals summary',
  'goals.summaryPctAria':         'Overall progress {pct}',
  'goals.empty':                  'No savings goals yet',
  'goals.emptyHint':              'Add a goal to start tracking your savings',
  'goals.addGoal':                'Add goal',
  'goals.editGoal':               'Edit goal',
  'goals.deleteGoal':             'Delete goal',
  'goals.deleteConfirm':          'Delete goal "{name}"?',
  'goals.field.name':             'Goal name',
  'goals.field.target':           'Target amount',
  'goals.field.current':          'Currently saved',
  'goals.field.deadline':         'Target date',
  'goals.field.trackingFrom':     'From date',
  'goals.field.icon':             'Icon',
  'goals.field.color':            'Color',
  'goals.field.allocationPct':    'Monthly share (%)',
  'goals.field.active':           'Active',
  'goals.paused':                 'Paused',
  'goals.activeOn':               'Active',
  'goals.activeOff':              'Paused',
  'goals.pctSumUnder':           'Current sum: {sum}% (< 100 OK, untracked = general pool)',
  'goals.pctSumOver':            'Current sum: {sum}% (> 100 not allowed)',
  'goals.allocationHint':         '{pct}% / month · ~{months} months',
  'goals.mode.auto':              'Auto',
  'goals.mode.manual':            'Manual',
  'goals.eta':                    'ETA: {days} days',
  'goals.etaMonths':              'ETA: {months} months',
  'goals.etaDate':                'ETA: {date}',
  'goals.etaNoHistory':           '—',
  'goals.completed':              'Completed',
  'goals.completedOver':          'Done · +{amount} over',
  'goals.progressAria':           '{name} saved {pct}',
  'goals.overrides':              'Pre-filled amount',
  'goals.section':                'Savings goals ({count})',  'accounts.title': 'Accounts & Wallets',
  'transfer.title': 'Transfer',
  'accounts.widgetTotal': 'Total across all accounts',
  'accounts.widgetEmpty': 'No accounts yet',
  'chart.viewAsChart': 'View as chart',
  'chart.close': 'Close',
  'transfer.mode': 'Transfer mode',
  'transfer.from': 'From account',
  'transfer.to': 'To account',
  'transfer.sameAccount': 'From and To accounts must be different',
  'transfer.success': 'Transfer recorded',
  'transfer.filter': 'Transfers only',
  'transfer.tag': 'transfer',
  // Phase 203: specific transfer validation errors. Before, every
  // failure showed 'transfer.sameAccount' — so "pick a destination
  // account" was reported as "source and destination must differ".
  'transfer.errMissingFrom':     'Choose the account to transfer from',
  'transfer.errMissingTo':       'Choose the account to transfer to',
  'transfer.errInvalidAmount':   'Enter an amount greater than zero',
  'transfer.errAccountMissing':  'That account no longer exists',
  'transfer.noAccountsHint':     'Add an account in Settings before recording a transfer',
  'accounts.label': 'Account',
  'accounts.add': 'Add account',
  'accounts.all': 'All accounts',
  'accounts.defaultName': 'Cash',


  'settings.title':      'Settings',
  'settings.subnavLabel': 'Settings sections',
  'settings.subnavCurrency': 'Currency',
  'settings.subnavCards': 'Cards',
  'settings.subnavRecurring': 'Recurring',
  'settings.subnavCategories': 'Categories',
  'settings.subnavGoals': 'Goals',
  'settings.subnavData': 'Data',
  'settings.subnavAbout': 'About',
  'settings.section.cash':           'Cash',
  'settings.section.cards':          'Credit cards ({n})',
  'settings.section.recurring':      'Monthly recurring income/expense ({n})',
  'settings.section.expenseCats':    'Expense categories ({n})',
  'settings.section.incomeCats':     'Income categories ({n})',
  'settings.section.sync':           'Google sync',
  'settings.section.data':           'Data',
  'settings.section.currency':       'Currency',
  'settings.section.appearance':     'Appearance',
  'settings.section.about':          'About',
  'settings.section.language':       'Language',

  'settings.language.label':     'Interface language',
  'settings.language.help':      'Takes effect immediately.',

  'settings.appearance.dark':    'Dark mode',
  'settings.appearance.compact': 'Compact layout',

  'settings.about.storage':      'Storage: local SQLite ({path})',
  'settings.about.localOnly':    'All data stays on your device, no cloud.',
  'settings.about.title':        'About',
  'settings.cardName':           'Card name',
  'settings.cardNamePlaceholder': 'e.g. HSBC Platinum',
  'settings.dueDay':             'Due day',
  'settings.outstandingAmount':  'Outstanding amount',
  'settings.symbolExists':       'This symbol already exists',
  'settings.addSymbolFailed':    'Failed to add symbol: {msg}',
  'settings.removeSymbolConfirm':'Remove symbol "{symbol}"?',
  'settings.keepOneSymbol':      'Keep at least one symbol',
  'settings.removeSymbolFailed': 'Failed to remove symbol: {msg}',

  'settings.recurring.add':      'Add',
  'settings.recurring.edit':     'Edit',
  'settings.recurring.delete':   'Delete',
  'settings.recurring.monthly':  'Day {n} each month',
  'settings.recurring.addTitle': 'New recurring rule',
  'settings.recurring.editTitle':'Edit recurring rule',
  'settings.recurring.type':     'Type',
  'settings.recurring.category': 'Category',
  'settings.recurring.amount':   'Amount',
  'settings.recurring.day':      'Day of month',
  'settings.recurring.dayPlaceholder': 'e.g. 1 (monthly)',
  'settings.recurring.note':     'Note',
  'settings.recurring.notePlaceholder': 'e.g. Monthly salary',
  'settings.recurring.from':     'Start month',
  'settings.recurring.to':       'End month (optional)',
  'settings.recurring.autoApplied': '📌 Auto-recorded {n} recurring transaction(s):\n{lines}',
  'settings.recurring.cancel':   'Cancel',
  'settings.recurring.save':     'Save',
  'settings.recurring.deleteConfirm': 'Delete this recurring rule?',
  'settings.recurring.amountPlaceholder': 'e.g. 30000',
  'settings.recurring.fromPlaceholder': 'Start month',
  'settings.recurring.toPlaceholder': 'No end date',
  'settings.recurring.period':   '{from} → {to}',

  'settings.category.name':      'Name',
  'settings.category.type':      'Type',
  'settings.category.icon':      'Icon',
  'settings.category.color':     'Color',
  'settings.category.addNew':    'New category',
  'settings.category.editOne':   'Edit category',
  'settings.category.cancel':    'Cancel',
  'settings.category.save':      'Save',
  'settings.category.nameRequired':'Please enter a name',
  'settings.category.deleteConfirm':'Delete category "{name}"?',
  'settings.category.namePlaceholder': 'e.g. Subscription',
  'settings.category.expense': 'Expense',
  'settings.category.income': 'Income',
  'settings.category.colorAria': 'Color {color}',
  // Phase 79f: defaults have a small badge + enable/disable toggle.
  'settings.category.defaultBadge': 'Default',
  'settings.category.defaultHint':  'Default categories cannot be edited or deleted — only enabled/disabled',
  'settings.category.enable':       'Enable',
  'settings.category.disable':      'Disable',

  'common.back':         'Back',
  'common.cancel':       'Cancel',
  'common.save':         'Save',
  'common.search':       'Search',
  'common.delete':       'Delete',
  'common.confirmDelete':'Confirm delete?',
  'common.edit':         'Edit',
  'common.confirm':      'Confirm',
  'common.close':        'Close',
  'common.failed':       'Save failed: {msg}',
  'common.failedDelete': 'Delete failed: {msg}',
  'common.deleteConfirm':'Are you sure?',
  'common.today':        'Today',
  'common.unknown':      'Unnamed',
  'common.optional':     'optional',
  'common.none':         'none',

  'err.generic':         'Something went wrong: {msg}',

  'signin.title':        'Connect a Google account',
  'signin.subtitle':     'Sync your data between this device and Google Drive',
  'signin.button':       'Sign in with Google',
  'signin.skip':         'Skip for now (local use)',
  'signin.connected':    'Connected',
  'signin.disconnect':   'Sign out',

  'cmd.placeholder':     'Search commands, pages or transactions...',
  'cmd.section.pages':   'Pages',
  'cmd.section.actions': 'Commands',
  'cmd.section.recent':  'Recent transactions',
  'cmd.theme.toggle':    'Toggle theme',
  'cmd.theme.dark':      'Dark mode',
  'cmd.theme.light':     'Light mode',
  'cmd.lang.switch':     'Switch language',
  'cmd.shortcutHint':    'Press ⌘K / Ctrl K to open search',

  'placeholder.noData':  'No data yet',
  'placeholder.addFirst':'Add the first one',

  'dashboard.refresh.refreshing': '⟳ Refreshing…',
  'dashboard.refresh.release': '↓ Release to refresh',
  'dashboard.kpi.incomeYear': 'Income (Year)',
  'dashboard.kpi.incomeDay': 'Income (Today)',
  'dashboard.kpi.income5y': 'Income (5Y)',
  'dashboard.kpi.expenseYear': 'Expense (Year)',
  'dashboard.kpi.expenseDay': 'Expense (Today)',
  'dashboard.kpi.expense5y': 'Expense (5Y)',
  'dashboard.kpi.netYear': 'Net (Year)',
  'dashboard.kpi.netDay': 'Net (Today)',
  'dashboard.kpi.net5y': 'Net (5Y)',
  'dashboard.rangeLabel.year': 'Full year (12 months)',
  'dashboard.rangeLabel.week': 'Last 7 days',
  'dashboard.rangeLabel.halfYear': 'Last 6 months',
  'dashboard.rangeLabel.fiveYear': 'Last 5 years (60 months)',
  'dashboard.filter.title': 'Filters',
  'dashboard.filter.openFilters': 'Filter',
  'dashboard.filter.typeLabel': 'Type',
  'dashboard.filter.categoriesLabel': 'Categories',
  'dashboard.filter.amountLabel': 'Amount range',
  'dashboard.filter.amountMin': 'Min',
  'dashboard.filter.amountMax': 'Max',
  'dashboard.trend.yoyLabel': 'vs {ym}',
  'dashboard.trend.yoyIncome': 'Income (prior year)',
  'dashboard.trend.yoyExpense': 'Expense (prior year)',
  'dashboard.trend.viewLabel': 'Trend view',
  'dashboard.trend.viewTimeline': 'Timeline',
  'dashboard.trend.viewByYear': 'By year',
  'dashboard.trend.metricLabel': 'Metric',
  'dashboard.onlyShowing': 'Only showing {name}',
  'dashboard.autoAppliedFmt': '📌 Auto-recorded {n} recurring transactions',
  'dashboard.card.dueTodayTitle': '💳 {name} due today',
  'dashboard.card.dueInDaysTitle': '💳 {name} due in {n} days',
  'dashboard.card.unpaidHint': '{amount} unpaid · remember to pay',
  'dashboard.card.graceSuffix': '({n} days of grace remaining)',
  'filter.all': 'All',
  'filter.thisMonth': 'This month',
  'filter.lastMonth': 'Last month',
  'filter.thisYear': 'This year',
  'filter.date': 'Date',
  'filter.amount': 'Amount',
  'filter.sortByDate': 'Sort by date',
  'filter.sortByAmount': 'Sort by amount',
  'filter.noMatches': 'No transactions in this period',
  'dashboard.card.overdue': '{n} days overdue · {date}',
  'dashboard.card.paidOn': 'Paid on {date}',
  'dashboard.card.allPaid': 'All cards paid for this cycle',
  'dashboard.card.dueToday': 'Due today · {date}',
  'dashboard.card.dueTomorrow': 'Due tomorrow · {date}',
  'dashboard.card.dueInDaysFmt': 'Due in {n} days · {date}',
  'placeholder.empty': 'No data',
  'common.loadingDots': 'Loading…',
  'settings.category.editorHint': 'Add a name, choose a type, then select an icon and color.',
  'dashboard.filtering': 'Only showing ',
  'common.clear': 'Clear',
  'dashboard.netWorthSummary': 'Income {income} · Expense {expense}',
  'dashboard.categoryBreakdown': 'Category breakdown',
  'common.manage': 'Manage',
  'dashboard.cardReminder': 'Card payment reminders',
  'dashboard.recentTransactions': 'Recent transactions',
  'budgets.alerts': 'Budget alerts',
  'tx.seeAll': 'See all',
  'tx.prevMonth': 'Previous month',
  'tx.nextMonth': 'Next month',
  'common.clearSearch': 'Clear search',
  'tx.noSearchMatch': 'No transactions matching "{q}"',
  'add.dirtyConfirm': 'Discard this unsaved transaction?',
  // Phase 106 (M-36): first-transaction celebration banner.
  'add.firstTxCelebration': '🎉 First entry logged! Welcome aboard',
  'common.saving': 'Saving…',
  'add.noCardsHint': 'No credit cards yet. Add one in Settings.',
  'budgets.deleteConfirm': 'Clear this category budget?',
  'budgets.clear': 'Clear',
  'budgets.description': 'Set a monthly limit per category. Dashboard alerts you when you go over.',
  'budgets.thisMonthUsage': 'This month {spent} / {limit}',
  'budgets.limitPlaceholder': 'Monthly limit',
  'budgets.invalidAmount': 'Budget must be a positive number',
  'settings.cardsTitle': 'Credit cards ({count})',
  'settings.cardsEmpty': 'No credit cards yet. Click "+ New" to add one.',
  'settings.editCard': 'Edit credit card',
  'settings.deleteCard': 'Delete credit card',
  'settings.newCard': 'New credit card',
  'settings.recurringTitle': 'Recurring monthly ({count})',
  'settings.editRecurring': 'Edit recurring rule',
  'settings.deleteRecurring': 'Delete recurring rule',
  'settings.newRecurring': 'New recurring rule',
  'settings.expenseCatsTitle': 'Expense categories ({count})',
  'settings.incomeCatsTitle': 'Income categories ({count})',
  'settings.newCategory': 'New category',
  'settings.editCategory': 'Edit category',
  'settings.deleteCategoryConfirm': 'Delete category "{name}"?',
  'settings.deleteRecurringConfirm': 'Delete this recurring rule?',
  'settings.deleteCardConfirm': 'Delete this credit card?',
  'signin.loadGoogleFailed': 'Could not load Google Sign-In: {msg}',
  'signin.tagline': 'Sign in with Google. Your data belongs only to you.',
  'signin.googleNotConfigured': 'Google Sign-In not configured (GOOGLE_CLIENT_ID missing)',
  'signin.signingIn': 'Signing in…',
  'cmd.newTx': 'New transaction',
  'cmd.goTo': 'Go to',
  'appearance.theme': 'Theme',
  'appearance.light': 'Light',
  'appearance.dark': 'Dark',
  // Phase 81: replaced misleading "follows your system" hint with one
  // that accurately describes the two-option toggle.
  'appearance.themeHint': 'Takes effect immediately',
  'appearance.notifications': 'Browser notifications',
  'appearance.notifDenied': 'Notification permission denied. Enable it in your browser settings.',
  'appearance.notifLabel': 'Notify when credit card grace period is critical',
  // Phase 81: removed dev-environment copy ("In dev, localhost …").
  'appearance.notifHint': 'Browser notification permission required.',
  'recap.title': 'Weekly recap',
  'recap.expenseFmt': 'Spent {amount} this week',
  'recap.topCategoryFmt': 'Top: {category} ({amount})',
  'recap.upVsLastWeek': '↑ vs last week',
  'recap.downVsLastWeek': '↓ vs last week',
  'appearance.weeklyRecap': 'Weekly recap notification',
  'appearance.weeklyRecapHint': 'Get a Sunday reminder of your weekly spending.',
  'appearance.compactFilter': 'Compact filter bar',
  'appearance.compactFilterHint': 'Hide category chips to save header space',
  // Phase 81: distinct section heading (was duplicating the toggle label).
  'appearance.compactFilterTitle': 'Transaction filters',
  'installments.title': 'Installments',
  'installments.add': 'Add installment',
  'installments.empty': 'No installments yet',
  'installments.total': 'Total',
  'installments.monthlyAmount': 'Monthly',
  'installments.periods': '{paid}/{total} paid',
  'installments.remaining': '{n} periods left',
  'installments.nextPayment': 'Next payment',
  'installments.complete': 'Complete',
  'installments.markPaid': 'Mark next payment paid',
  'installments.markEnded': 'Mark plan complete',
  'installments.note': 'Note (what was bought)',
  'installments.totalAmount': 'Total amount',
  'installments.totalPeriods': 'Number of periods',
  'installments.startMonth': 'Start month',
  'installments.card': 'Credit card',
  'installments.future.title': 'Upcoming installments',
  'installments.future.subtitle': '{n} future payments totaling {total}',
  'installments.notify.title': 'Installment payment due',
  'installments.notify.body': '{card} · {amount} · 第 {period}/{total} 期{note_sfx}',
  'installments.notify.noteSuffix': ' ({note})',
  'currency.title': 'Currency display',
  'currency.saveFailed': 'Save failed: {msg}',
  'currency.addFailed': 'Add failed: {msg}',
  'currency.keepOne': 'Keep at least one symbol',
  'currency.deleteSym': 'Delete {sym}',
  'currency.addAria': 'Add new currency symbol',
  'currency.preview': 'Current display: {amount}',
  'data.title': 'Data management',
  'data.importHint': 'Import transactions from a CSV file',
  'data.importAria': 'Select CSV file',
  'data.importColumns': 'Columns: type, amount, category, occurred_on, note, tags',
  'data.importing': 'Importing…',
  'data.importOk': '{imported} imported, {skipped} skipped',
  'data.importOkErrors': ' · {n} errors',
  'data.importFailed': 'Import failed: {msg}',
  'data.exportHint': 'Download all transactions as a CSV file',
  'data.exportBtn': 'Export CSV',
  'data.exporting': 'Exporting…',
  'data.exportOk': 'Exported {n} transactions',
  'data.exportFailed': 'Export failed: {msg}',
  'data.clearHint': 'Delete all transactions (categories, budgets, settings are preserved)',
  'data.clearAll': 'Delete all transactions',
  'data.clearConfirm': 'Delete all transactions? This cannot be undone.',
  'data.clearing': 'Deleting…',
  'data.confirmClear': 'Confirm delete',
  'data.clearedN': 'Deleted {n} transactions',
  'data.clearFailed': 'Delete failed: {msg}',
  // Phase 47: redesigned DataSection visual hierarchy
  'data.dangerZone': 'Danger zone',
  'data.dangerZoneDesc': 'These actions cannot be undone. Use with care.',
  'data.importDrop': 'Click or drop a CSV file here',
  'data.importDropHint': 'Supports .csv format',
  'account.title': 'Account binding',
  'account.subtitle': 'Sync to other devices.',
  'account.noName': '(no name)',
  'account.signOutConfirm': 'Sign out?',
  'account.signOut': 'Sign out',
  'account.saveFailed': 'Save failed: {msg}',
  // Phase 46: local-vs-cloud account UI
  'account.localBadge': 'Local account',
  'account.localDesc': 'Stored only on this device. No backup, no sync.',
  'account.deleteLocal': 'Delete local account',
  'account.deleteLocalConfirm': 'Delete this local account? All data on this device will be permanently erased.',
  'account.deleteLocalDone': 'Local account deleted',
  'account.connectGoogle': 'Connect Google account',
  'account.connectGoogleDesc': 'Sync transactions across devices.',
  'account.googleComingSoon': 'Coming soon — Phase B',
  'account.deleteLocalHint': 'This action cannot be undone.',
  // Phase 46b: bullet-style local-account description + new keys
  'account.connected': 'Connected',
  'account.localBullet.device': 'Stored on this device',
  'account.localBullet.noBackup': 'No backup',
  'account.localBullet.noSync': 'No sync',
  // Phase 40: developer card (local-only sample data)
  'developer.title': 'Developer',
  'developer.version': 'App version',
  'developer.localOnly': 'Local device only — sample data is written to your IndexedDB and never reaches the server.',
  'developer.seed500': 'Seed 500 sample transactions',
  'developer.seed100': 'Seed 100 sample transactions',
  'developer.seed10y': 'Seed 1200 / 10 years',
  'developer.seedConfirm': 'Insert {n} random sample transactions (spread over {y} years) into this device?',
  'developer.seedOk': 'Inserted {n} sample transactions.',
  'developer.resetTx': 'Delete all local transactions',
  'developer.resetConfirm': 'Delete ALL local transactions on this device? This cannot be undone.',
  'developer.resetOk': 'Deleted {n} transactions.',
  'developer.working': 'Working…',
  'developer.failed': 'Failed: {msg}',
  'topbar.search': 'Search',
  'topbar.searchTitle': 'Search (Cmd/Ctrl+K)',
  'topbar.themeLight': 'Switch to light',
  'topbar.themeDark': 'Switch to dark',
  'topbar.filters': 'Toggle filters',
  'topbar.searchTip': 'Press / or Cmd+K',
  'fab.newTx': 'New transaction',
  'common.refresh.release': '↓ Release to refresh',
  'common.refresh.refreshing': '⟳ Refreshing…',
  'budgets.notSet': 'No budgets set',
  'budgets.notSetHint': 'Go to Budgets to set a monthly limit',
  'budgets.budgetsCount': 'budgets',
  'budgets.overCount': 'over',
  'budgets.warnCount': 'near limit',
  'budgets.over': 'over',
  'budgets.warn': 'near',
  'budgets.progressAria': '{name} used {pct}',
  'tx.seeAllFmt': 'See all ({count})',
  'tx.emptyCta': 'New transaction',
  'tx.listCountFmt': '{shown} of {total} shown',
  'category.noExpense': 'No expenses yet',
  'settings.categoryNameRequired': 'Please enter a name',
  'settings.reorderFailed': 'Reorder failed: {msg}',
  'settings.moveUp': 'Move up',
  'settings.moveDown': 'Move down',
  'settings.reorder': 'Drag to reorder',
  'settings.cardSettleConfirm': 'Mark as paid? Outstanding for this cycle will reset to 0.',
  'settings.cardSettleTitle': 'Mark paid and reset outstanding',
  'settings.cardSettleFailed': 'Settle failed: {msg}',
  'settings.cardStatementDue': 'Statement {stmt} · Due {due}',
  'settings.cardDueToday': 'Due today',
  'settings.cardDueTomorrow': 'Due tomorrow',
  'settings.cardDueInDays': 'Due in {n} days',
  'settings.cardGraceRemaining': '{n} grace days left',
  'settings.cardOverdue': 'Overdue by {n} days',
  'settings.cardOutstanding': 'Outstanding: {amount}',
  'settings.cardSettle': 'Mark as paid',

  'settings.cardPaid': 'Paid',
  'settings.statementDay': 'Statement day',
  'settings.expiryMonth': 'Expiry month (MM)',
  'settings.expiryYear': 'Expiry year (YY)',
  'settings.expiryMonthPlaceholder': 'e.g. 8',
  'settings.expiryYearPlaceholder': 'e.g. 27',
  'settings.expiryHint': 'Optional. Month and year must both be set.',
  'settings.recurringHint': 'Once set, opening the Dashboard will auto-record this month\'s transactions (local time).',
  'signin.appTitle': 'Finance App',
  'common.add': 'Add',
  'common.all': 'All',
  'categories.餐飲': 'Food',
  'categories.交通': 'Transport',
  'categories.水費': 'Water',
  'categories.電費': 'Electricity',
  'categories.煤氣': 'Gas',
  'categories.居家': 'Household',
  'categories.投資': 'Investments',
  'categories.娛樂': 'Entertainment',
  'categories.購物': 'Shopping',
  'categories.醫療': 'Healthcare',
  'categories.稅務': 'Tax',
  // Phase 82b: renamed from 交卡數 to 卡數.
  'categories.卡數': 'Card payment',
  'categories.其他': 'Other',
  'categories.薪金': 'Salary',
  'categories.投資回報': 'Investment returns',
  'categories.獎金': 'Bonus',
  'cmd.ariaLabel': 'Command palette',
  'cmd.searchPlaceholder': 'Search transactions, categories, budgets, recurring, cards...',
  'cmd.loading': 'Loading…',
  'cmd.noResults': 'No results for "{q}"',
  'cmd.footerHint': '↑↓ to move · ↵ to confirm · ESC to close',
  'cmd.toOpen': 'to open',
  'cmd.expenseCat': 'Expense category',
  'cmd.incomeCat': 'Income category',
  'cmd.budget': 'budget',
  'cmd.perMonth': 'per month',
  'cmd.dayOfMonth': 'day',
  'cmd.outstanding': 'outstanding',
    'cardDetail.title': 'Card transactions',
    'cardDetail.empty': 'No transactions tagged to this card yet',
    'cardDetail.notFound': 'Card not found',
    'cardDetail.outstanding': 'Outstanding',
    'cardDetail.nextDue': 'Next due date',
    'cardDetail.cycle': 'Billing cycle',
    'cardDetail.markPaid': 'Mark paid today',
    'cardDetail.transactions': 'Transactions',
    'cardDetail.addTagged': 'Add transaction',
    'cardDetail.openCard': 'View card transactions for {name}',
    'cardDetail.paidOn':   'Paid on {date}',

    // Phase 102: First-time onboarding carousel.
    'onboard.step1.title':      'Set your language and currency',
    'onboard.step1.body':       'Pick the language and currency you use. You can change them later in Settings.',
    'onboard.step1.langLabel':  'Language',
    'onboard.step1.curLabel':   'Currency symbol',
    'onboard.step1.preview':    'Preview',
    'onboard.step2.title':      'Log your first transaction',
    'onboard.step2.body':       'Logging a transaction takes seconds. You can edit or delete any entry later.',
    'onboard.step2.bullet1':    'Pick type (expense / income)',
    'onboard.step2.bullet2':    'Enter amount and choose a category',
    'onboard.step2.bullet3':    'Saves instantly and shows on the home page',
    'onboard.step2.tipNote':    'Tip: on your first add you’ll see 3 short tips. Tap “Got it” to dismiss each one.',
    'onboard.step3.title':      'Local-first + cloud backup',
    'onboard.step3.body':       'Your data lives on this device and works offline. Sign in with Google to sync across devices.',
    'onboard.step3.bullet1':    'Local storage: fast, works offline',
    'onboard.step3.bullet2':    'Google sign-in (optional): cross-device sync',
    'onboard.step3.signinNote': 'After signing in, local data is pushed to the cloud automatically.',
    'onboard.back':             'Back',
    'onboard.next':             'Next',
    'onboard.skip':             'Skip',
    'onboard.later':            'Maybe later',
    'onboard.logNow':           'Log one now',
    'onboard.start':            'Start using the app',
    'onboard.tooltip.type':     '👆 Keep expenses and income separate for clearer stats.',
    'onboard.tooltip.amount':   '💰 Use the quick-keypad to enter the amount.',
    'onboard.tooltip.category': '🏷️ Picking a category makes trends easier later.',
    'onboard.tooltip.gotIt':    'Got it',
    'onboard.replay.title':     'Tutorial',
    'onboard.replay.body':      'Replay the first-time walkthrough.',
    'onboard.replay.button':    'Replay tutorial',

    // Phase 104: collapsible group titles + privacy mode.
    'settings.group.prefs':    'Preferences',
    'settings.group.tracking': 'Tracking',
    'settings.group.data':     'Data',
    'settings.group.help':     'Help',
    'privacy.title':           'Hide amounts',
    'privacy.body':            'When on, amounts on Dashboard / Transactions / Budgets are masked. Tap any amount to reveal it for 5 seconds.',

    // Phase 103: Reset All Settings (destructive).
    'resetAll.title':         'Reset all settings',
    'resetAll.body':          'Wipe all local data: transactions, accounts, categories, budgets, recurring, cards, goals, installments, settings. Server-side data is preserved. The first-time tutorial will re-appear after reload.',
    'resetAll.button':        'Reset all settings',
    'resetAll.confirmTitle':  'Confirm wipe of all local data?',
    'resetAll.confirmBody':   'This cannot be undone. Type {phrase} to confirm.',
    'resetAll.confirmLabel':  'Type DELETE',
    'resetAll.confirmButton': 'Wipe permanently',
    'resetAll.failed':        'Reset failed: {msg}',

    // Phase 202d/202e: Sync section + destructive server wipe.
    'settings.sync.title':                  'Cross-device sync',
    'settings.sync.desc':                   'Pull all data from your Google account back onto this device. Use on a new device or after a reinstall.',
    'settings.sync.button':                 'Re-sync now',
    'settings.sync.wipeButton':             'Wipe this device and re-sync',
    'settings.sync.wipeConfirmTitle':       'This clears all local transactions, categories, credit cards, recurring rules, budgets, goals and accounts, then re-pulls from the server.',
    'settings.sync.wipeConfirmWarn':        'Local data that has not yet uploaded to the server will be lost permanently. Re-sync first to confirm the server has your data.',
    'settings.sync.wipeExecute':            'Yes, wipe and re-sync',
    'settings.sync.wipeServerButton':       'Wipe server data and sign in again',
    'settings.sync.wipeServerConfirmTitle': 'This permanently deletes all your transactions, categories, credit cards, recurring rules, budgets, goals, settings and account record from the server.',
    'settings.sync.wipeServerConfirmWarn':  'Server data cannot be recovered. The page will reload afterwards and you will need to sign in with Google again.',
    'settings.sync.wipeServerExecute':      'Yes, wipe the server',
    'common.error':                         'Something went wrong',

  // Phase 208 / card 208-D1 — recurring-transaction reminders.
  'recurring.reminder.title': 'Reminder',
  'recurring.reminder.countFmt': '{count} upcoming fixed transactions',
  'recurring.reminder.itemFmt': '{category} · {amount} · {when}',
  'recurring.reminder.dueToday': 'Due today',
  'recurring.reminder.dueInDays': 'Due in {n} days',
  'recurring.reminder.appliedFmt': '{name} was added automatically',
  'recurring.reminder.toggleLabel': 'Remind me before this posts',
  'recurring.reminder.leadLabel': 'Remind me {n} days before',
  'recurring.reminder.globalToggle': 'Recurring transaction reminders',
  'recurring.reminder.globalHint': "You'll be notified the next time you open the app, before fixed income/expense posts.",
};
